<a [href]="url|translate"  target="_blank">

         <span [className]="labelClass"  [style]="labelStyle" [innerHTML]="label|translate:labelParam"></span>

         <span [className]="labelClass"  [style]="labelStyle" translate>
               <ng-content></ng-content>
         </span>
</a>


